<mat-form-field class="full-width">
  <mat-label>{{label}}</mat-label>
  <input matInput [attr.name]="name" [(ngModel)]="dateTime"
         [owlDateTimeTrigger]="dtPicker3" [owlDateTime]="dtPicker3" required="{{required}}">
  <mat-icon class="clickable" matSuffix fontSet="material-icons-outlined" [owlDateTimeTrigger]="dtPicker3">date_range</mat-icon>
  <owl-date-time #dtPicker3></owl-date-time>
  <mat-hint>Tag {{name}}</mat-hint>
  <mat-error>Tag {{name}} is required</mat-error>
</mat-form-field>
